module.exports = __webpack_public_path__ + "static/media/isb.84f8a91a.webp";